(function (Lfl, $, undefined) {
    (function (Modals, $, undefined) {
        Lfl.Modals.Displayer;

        (function (Displayer, $, undefined) {
            const MODAL_CLASS = 'modal';
            let $modalsSection;

            Displayer.modalsSectionName = 'modals_section';
            Displayer.getModalDialogueUrl = '';

            /**
             * @param modalsSectionName
             * @param getModalDialogueUrl
             * @memberOf Lfl.Modals.Displayer
             */
            Displayer.init = function (modalsSectionName, getModalDialogueUrl) {
                this.modalsSectionName = modalsSectionName;
                this.getModalDialogueUrl = getModalDialogueUrl;
            };

            /**
             * Appends the provided modal to the appropriate section of the page.
             *
             * @memberOf Lfl.Modals.Displayer
             * @param $modalContent
             */
            Displayer.appendBootstrapModal = function ($modalContent) {
                if (typeof $modalsSection === 'undefined') {
                    $modalsSection = $('#' + this.modalsSectionName);
                }

                $modalsSection.append($modalContent);
            };

            /**
             * Whether some modal is currently in the process of being displayed.
             *
             * This is required to prevent a "lockdown" by calling modal.show() multiple times on the same modal.
             *
             * @type {boolean}
             */
            let displayingModal = false;

            /**
             * Appends and displays the provided modal.
             *
             * @memberOf Lfl.Modals.Displayer
             * @param $modal
             * @param {boolean} [destroyAfterHiding] Whether the modal should be removed from the page when it becomes no
             * longer visible.
             */
            Displayer.displayBootstrapModal = function ($modal, destroyAfterHiding) {

                if (typeof $modal === 'undefined') {
                    throw "Undefined was provided instead of $modal. Cannot proceed.";
                }

                if(displayingModal === true) {
                    console.warn("A modal dialog is already in the process of being displayed. Not going to open another.");
                    return;
                }

                displayingModal = true;

                if (typeof destroyAfterHiding === 'undefined') {
                    destroyAfterHiding = false;
                }

                if ($modal.hasClass(MODAL_CLASS) === false || $modal.attr('role') !== "dialog") {
                    console.warn("The jquery object provided to the displayBootstrapModal does not seem to repsesent a DOM element containing such a modal. " +
                        "The class and/or role attribute is not set correctly.\n" +
                        "The provided object is:\n");
                    console.warn($modal);
                }

                const DATA_IS_OPENING_NAME = 'lfl.modals.isOpening';

                if ($modal.data(DATA_IS_OPENING_NAME) !== true) {
                    if (wasModalInitialized($modal) === false) {
                        $modal.modal({
                            show: true
                        });
                    } else {
                        $modal.modal('show');
                    }

                    $modal.trigger($.Event('lfl.modal.show', { /* No data to pass */}));
                }

                /* Make sure the modal is opened only once */

                // We have to make sure that the modal is not set to be open multiple times by rapid clicking
                $modal.data(DATA_IS_OPENING_NAME, true);

                $modal.on('shown.bs.modal', function (e) {
                    onOpen();
                    $modal.off('shown.bs.modal');

                    // Only after some time after the modal was displayed we allow it to be open again.
                    setTimeout(function () {
                        $modal.data(DATA_IS_OPENING_NAME, false);
                    }, 1000);
                });

                /* Add destruction handling */

                $modal.on('hidden.bs.modal', function (e) {
                    onClose();
                    if (destroyAfterHiding) {
                        $modal.remove();
                    }
                });

                displayingModal = false;
            };

            /**
             * Appends and displays the provided modal.
             *
             * @memberOf Lfl.Modals.Displayer
             * @param $modalContent
             * @param {boolean} [destroyAfterHiding] Whether the modal should be removed from the page when it becomes no
             * longer visible.
             */
            Displayer.appendAndDisplayBootstrapModal = function ($modalContent, destroyAfterHiding) {
                Displayer.appendBootstrapModal($modalContent);
                Displayer.displayBootstrapModal($modalContent, destroyAfterHiding);
            };

            /**
             * Creates a modal dialogue from provided parameters.
             *
             * @param {string} text
             * @param {string} header
             * @param {boolean} [displayCentered]
             * @param {string} [size] Small, medium or large
             * @param {string} [headerIcon] An icon that should be displayed in the header.
             * @param {string} [cssClasses] A string of comma separated css classes.
             * @param {string|undefined} [failAlertMessage] A message that should be displayed if the modal could not have been
             * created.
             * @memberOf Lfl.Modals.Displayer
             */
            Displayer.createBootstrapModalFromText = function (
                text,
                header,
                displayCentered,
                size,
                headerIcon,
                cssClasses,
                failAlertMessage
            ) {

                if (typeof displayCentered === 'undefined') {
                    displayCentered = false;
                }

                if (typeof size === 'undefined') {
                    size = 'medium';
                }

                if (typeof failAlertMessage === 'undefined') {
                    failAlertMessage =
                        header + "\n" +
                        text + '\n' + '\n' +
                        "Je nám líto, že se systému nepovedlo vykreslit hezčí chybovou hlášku.";
                }

                if (typeof headerIcon === 'undefined') {
                    headerIcon = '';
                }

                if (typeof cssClasses === 'undefined') {
                    cssClasses = '';
                }

                const data = {
                    text: text,
                    header: header,
                    displayCentered: displayCentered,
                    headerIcon: headerIcon,
                    cssClasses: cssClasses,
                    size: size
                };

                const MD = this;

                $.ajax({
                    type: 'post',
                    url: this.getModalDialogueUrl,
                    data: JSON.stringify(data),
                    contentType: 'application/json',
                    success: function (receivedData) {
                        try {
                            MD.appendAndDisplayBootstrapModal($(receivedData), true);
                        } catch (e) {
                            console.error('The server sent a response, but the client side code was unable to create'
                                + ' the modal dialogue! The response was:');
                            console.error(receivedData);
                            console.error('And the error was:');
                            console.error(e);
                            alert(failAlertMessage);
                        }
                    },
                    error: function (receivedData) {
                        console.error('The server was unable to create modal dialogue! The response was:');
                        console.error(receivedData);

                        alert(failAlertMessage);
                    }
                });
            };

            function onOpen() {
                if (MobileCallbacks.isMobile()) {
                    Lfl.Mobile.Sender.onModalOpen();
                }
            }

            function onClose () {
                if (MobileCallbacks.isMobile()) {
                    Lfl.Mobile.Sender.onModalClosed();
                }
            }

            function wasModalInitialized($modal) {
                return typeof $modal.data('bs.modal') !== 'undefined';
            }
        }(Modals.Displayer = Modals.Displayer || {}, jQuery));
    }(Lfl.Modals = Lfl.Modals || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
